module.exports = __webpack_public_path__ + "img/14.56cb4a04.png";